export const MODAL_OPENED = 'joraemployer/modal/MODAL_OPENED';
export const MODAL_CLOSED = 'joraemployer/modal/MODAL_CLOSED';
